import '@babel/polyfill';
import 'intersection-observer';
import 'eligrey-classlist-js-polyfill';
import 'nodelist-foreach-polyfill';
import objectFitImages from 'object-fit-images';

objectFitImages();
